import { render, staticRenderFns } from "./select-chart-categories.vue?vue&type=template&id=dbe9fd32&scoped=true&"
import script from "./select-chart-categories.vue?vue&type=script&lang=js&"
export * from "./select-chart-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe9fd32",
  null
  
)

export default component.exports